import type { Model } from '@patsnap/tahiti-core';
import type { FeatureCompareState } from '../types';

export const FeatureCompareModel = Symbol.for('FeatureCompareModel');

export interface FeatureCompareModel extends Model<FeatureCompareState> {
    defaultModelData: FeatureCompareState;
}